<template>
  <div>
    <v-row>
      <v-col cols="8">
        <div class="vid">
          <div class="embed-container">
            <iframe
              :src="videoConfig"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
            ></iframe>
          </div>
          <div class="texto">
            {{ videoTitle }}
          </div>
        </div>
      </v-col>
      <v-col class="linha1" cols="4">
        <!-- Como identificar Sintomas Cancro Europeu na Brotação e Floração -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/cEM1erlwfFA';
            videoTitle =
              'Como identificar Sintomas Cancro Europeu na Brotação e Floração';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video1.jpg"
            height="100%px"
          ></v-img>

          <v-card-title
            class="d-flex align-center justify-center pa-4 mx-auto titulo"
          >
            Como identificar Sintomas Cancro Europeu na Brotação e Floração
          </v-card-title>
        </v-card>

        <!-- Como diferenciar sintomas do cancro europeu e o de papel -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/IOdGqUsxHm4';
            videoTitle =
              'Como diferenciar sintomas do cancro europeu e o de papel';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video2.jpg"
            height="200px"
          ></v-img>

          <v-card-title
            class="d-flex align-center justify-center pa-4 mx-auto titulo"
          >
            Como diferenciar sintomas do cancro europeu e o de papel
          </v-card-title>
        </v-card>

        <!-- Limpeza de Frutos no Pomar -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/L-xwFep2RjQ';
            videoTitle = 'Limpeza de Frutos no Pomar';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video3.jpg"
            height="200px"
          ></v-img>

          <v-card-title
            class="d-flex align-center justify-center pa-4 mx-auto titulo"
          >
            Limpeza de Frutos no Pomar
          </v-card-title>
        </v-card>

        <!-- Procurando cancros no manejo de poda -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/nCxtjMNhKqg';
            videoTitle = 'Procurando cancros no manejo de poda';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video4.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Procurando cancros no manejo de poda
          </v-card-title>
        </v-card>

        <!-- Manejo de Fungicidas no Período de Queda de Folhas -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/XJLttBRWCFs';
            videoTitle = 'Manejo de Fungicidas no Período de Queda de Folhas';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video5.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Manejo de Fungicidas no Período de Queda de Folhas
          </v-card-title>
        </v-card>

        <!-- Procurando Cancros no Manejo de queda de folhas -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/pldU7fLMgRo';
            videoTitle = 'Procurando Cancros no Manejo de queda de folhas';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video6.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Procurando Cancros no Manejo de queda de folhas
          </v-card-title>
        </v-card>

        <!-- Manejo da Queda de Folhas -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/zbYzprHfMyQ';
            videoTitle = 'Manejo da Queda de Folhas';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video7.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Manejo da Queda de Folhas
          </v-card-title>
        </v-card>

        <!-- Por que erradicar ao invés de manejar 1 -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/HnWyuxZ_xxY';
            videoTitle = 'Por que erradicar ao invés de manejar 1';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video8.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Por que erradicar ao invés de manejar 1
          </v-card-title>
        </v-card>

        <!-- Por que erradicar ao invés de manejar 2 -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/lAb92_MdwZQ';
            videoTitle = 'Por que erradicar ao invés de manejar 2';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video9.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Por que erradicar ao invés de manejar 2
          </v-card-title>
        </v-card>

        <!-- Procurando cancros no manejo pré colheita -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/c1HmPu8KzrM';
            videoTitle = 'Procurando cancros no manejo pré colheita';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video10.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Procurando cancros no manejo pré colheita
          </v-card-title>
        </v-card>

        <!-- Como identificar Sintomas Cancro Europeu no Raleio -->
        <v-card
          max-width="344"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/UpdwwN8kXXA';
            videoTitle = 'Como identificar Sintomas Cancro Europeu no Raleio';
            topFunction();
          "
          class="mx-auto mb-10 cards"
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video11.jpg"
            height="200px"
          ></v-img>

          <v-card-title class="d-flex align-center justify-center pa-4 mx-auto">
            Como identificar Sintomas Cancro Europeu no Raleio
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="vid2">
      <div>
        <div class="embed-container">
          <iframe
            :src="videoConfig"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </div>
        <div class="texto">
          {{ videoTitle }}
        </div>
      </div>
    </v-card>
    <v-row class="linha2" style="margin-top:30px">
      <v-col>
        <!-- Como identificar Sintomas Cancro Europeu na Brotação e Floração -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/cEM1erlwfFA';
            videoTitle =
              'Como identificar Sintomas Cancro Europeu na Brotação e Floração';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video1.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Como identificar Sintomas Cancro Europeu na Brotação e Floração
          </v-card-title>
        </v-card>

        <!-- Como diferenciar sintomas do cancro europeu e o de papel -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/IOdGqUsxHm4';
            videoTitle =
              'Como diferenciar sintomas do cancro europeu e o de papel';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video2.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Como diferenciar sintomas do cancro europeu e o de papel
          </v-card-title>
        </v-card>

        <!-- Limpeza de Frutos no Pomar -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/L-xwFep2RjQ';
            videoTitle = 'Limpeza de Frutos no Pomar';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video3.jpg"
            height="400px"
          ></v-img>

          <v-card-title> Limpeza de Frutos no Pomar</v-card-title>
        </v-card>

        <!-- Procurando cancros no manejo de poda -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/nCxtjMNhKqg';
            videoTitle = 'Procurando cancros no manejo de poda';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video4.jpg"
            height="100%"
          ></v-img>

          <v-card-title> Procurando cancros no manejo de poda </v-card-title>
        </v-card>

        <!-- Manejo de Fungicidas no Período de Queda de Folhas -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/XJLttBRWCFs';
            videoTitle = 'Manejo de Fungicidas no Período de Queda de Folhas';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video5.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Manejo de Fungicidas no Período de Queda de Folhas
          </v-card-title>
        </v-card>

        <!-- Procurando Cancros no Manejo de queda de folhas -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/pldU7fLMgRo';
            videoTitle = 'Procurando Cancros no Manejo de queda de folhas';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video6.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Procurando Cancros no Manejo de queda de folhas
          </v-card-title>
        </v-card>

        <!-- Manejo da Queda de Folhas -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/zbYzprHfMyQ';
            videoTitle = 'Manejo da Queda de Folhas';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video7.jpg"
            height="100%"
          ></v-img>

          <v-card-title> Manejo da Queda de Folhas </v-card-title>
        </v-card>

        <!-- Por que erradicar ao invés de manejar 1 -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/HnWyuxZ_xxY';
            videoTitle = 'Por que erradicar ao invés de manejar 1';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video8.jpg"
            height="100%"
          ></v-img>

          <v-card-title> Por que erradicar ao invés de manejar 1 </v-card-title>
        </v-card>

        <!-- Por que erradicar ao invés de manejar 2 -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/lAb92_MdwZQ';
            videoTitle = 'Por que erradicar ao invés de manejar 2';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video9.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Por que erradicar ao invés de manejar 2
          </v-card-title>
        </v-card>

        <!-- Procurando cancros no manejo pré colheita -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/c1HmPu8KzrM';
            videoTitle = 'Procurando cancros no manejo pré colheita';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video10.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Procurando cancros no manejo pré colheita
          </v-card-title>
        </v-card>

        <!-- Como identificar Sintomas Cancro Europeu no Raleio -->
        <v-card
          width="100VH"
          @click.prevent="
            videoConfig = 'https://www.youtube.com/embed/UpdwwN8kXXA';
            videoTitle = 'Como identificar Sintomas Cancro Europeu no Raleio';
            topFunction();
          "
          elevation="0"
        >
          <v-img
            src="../../../../styles/videos-thumbnails/video11.jpg"
            height="100%"
          ></v-img>

          <v-card-title>
            Como identificar Sintomas Cancro Europeu no Raleio
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "defaultVideo-main",
  data: () => ({
    //Procurando cancros no manejo pré colheita
    videoUrl: "https://www.youtube.com/embed/c1HmPu8KzrM",
    videoTitle: "Procurando cancros no manejo pré colheita"
  }),
  computed: {
    videoConfig: {
      get() {
        return this.videoUrl;
      },
      set(newUrl) {
        this.videoUrl = newUrl;
      }
    },
    imgConfig: {
      get() {
        return this.videoTitle;
      },
      set(newTitle) {
        this.videoTitle = newTitle;
      }
    }
  },
  methods: {
    topFunction() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .cards {
    max-width: 100%;
    max-height: 100%;
  }
  .texto {
    font-size: 30px;
  }
  .titulo {
    font-size: 15px;
  }
}
@media only screen and (min-width: 601px) {
  .cards {
    max-width: 60%;
    max-height: 80%;
  }
  .texto {
    font-size: 40px;
  }
  .titulo {
    font-size: 20px;
  }
}

@media only screen and (max-width: 836px) {
  .linha1 {
    display: none;
  }
  .vid2 {
    width: 100vh !important;
    height: 100% !important;
  }
  .texto {
    font-size: 20px;
    padding: center;
  }
  .vid {
    display: none;
  }
}
@media only screen and (min-width: 837px) {
  .linha2 {
    display: none;
  }
  .vid2 {
    display: none;
  }
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
